/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dnamw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By summing the molecular weights of each nucleotide residue and subtracting 61.96 for the removal of the terminal phosphate. Different residue masses are used for DNA and RNA.`)
};

const es_dnamw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumando los pesos moleculares de cada residuo de nucleótido y restando 61.96 por la eliminación del fosfato terminal. Se usan masas de residuos diferentes para ADN y ARN.`)
};

const de_dnamw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durch Summieren der Molekulargewichte jedes Nukleotidrests und Abziehen von 61,96 für die Entfernung des terminalen Phosphats. Für DNA und RNA werden unterschiedliche Restmassen verwendet.`)
};

const nl_dnamw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Door de molecuulgewichten van elk nucleotideresidu op te tellen en 61,96 af te trekken voor de verwijdering van het terminale fosfaat. Voor DNA en RNA worden verschillende residumassa's gebruikt.`)
};

const fr_dnamw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En additionnant les masses moléculaires de chaque résidu nucléotidique et en soustrayant 61,96 pour la suppression du phosphate terminal. Des masses de résidus différentes sont utilisées pour l'ADN et l'ARN.`)
};

const it_dnamw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sommando i pesi molecolari di ciascun residuo nucleotidico e sottraendo 61,96 per la rimozione del fosfato terminale. Per DNA e RNA vengono usate masse dei residui diverse.`)
};

const pt_br2_dnamw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somando os pesos moleculares de cada resíduo de nucleotídeo e subtraindo 61,96 pela remoção do fosfato terminal. Massas de resíduos diferentes são usadas para DNA e RNA.`)
};

const pt_dnamw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Somando as massas moleculares de cada resíduo de nucleótido e subtraindo 61,96 pela remoção do fosfato terminal. São usadas massas de resíduos diferentes para ADN e ARN.`)
};

const ja_dnamw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各ヌクレオチド残基の分子量を合計し、末端リン酸の除去分として61.96を引いて計算されます。DNAとRNAでは異なる残基質量が使われます。`)
};

const zh_dnamw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将每个核苷酸残基的分子量相加，并减去 61.96 以去除末端磷酸基团。DNA 和 RNA 使用不同的残基质量。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dnamw_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dnamw_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dnamw_faq_a1", locale)
	if (locale === "en") return en_dnamw_faq_a1(inputs)
	if (locale === "es") return es_dnamw_faq_a1(inputs)
	if (locale === "de") return de_dnamw_faq_a1(inputs)
	if (locale === "nl") return nl_dnamw_faq_a1(inputs)
	if (locale === "fr") return fr_dnamw_faq_a1(inputs)
	if (locale === "it") return it_dnamw_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_dnamw_faq_a1(inputs)
	if (locale === "pt") return pt_dnamw_faq_a1(inputs)
	if (locale === "ja") return ja_dnamw_faq_a1(inputs)
	return zh_dnamw_faq_a1(inputs)
};